import { useEffect } from "react";
import { SITE } from "../data/content";

// Lightweight per-page SEO: unique title, meta description and canonical URL.
export const SEO = ({ title, description, path = "" }) => {
  useEffect(() => {
    document.title = title || SITE.defaultTitle;
    const desc = description || SITE.defaultDescription;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", desc);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${SITE.baseUrl}${path || window.location.pathname}`);

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute("content", title || SITE.defaultTitle);
  }, [title, description, path]);
  return null;
};
